import { Link } from "react-router-dom";
import { Boxes } from "lucide-react";

export default function AuthLayout({ title, subtitle, children, footer }) {
  return (
    <div className="min-h-screen grid lg:grid-cols-2 bg-white">
      <div className="hidden lg:flex flex-col justify-between bg-navy grain-navy text-white p-12">
        <Link to="/" className="flex items-center gap-2 font-display font-extrabold text-xl">
          <span className="h-9 w-9 rounded-full overflow-hidden"><img src="/amden-logo.png?v=2" alt="Amden One" className="h-full w-full object-cover" /></span>
          Amden<span className="text-blue-400">One</span>
        </Link>
        <div>
          <h2 className="text-3xl font-bold leading-tight">Run your business in one place.</h2>
          <p className="mt-4 text-slate-300 max-w-md">CRM, quotes, invoices, jobs, planner and Alfie AI — the simple system trusted by sole traders and small teams.</p>
          <img src="https://static.prod-images.emergentagent.com/jobs/41623550-87c8-4e3e-9d15-90748eefa0dc/images/10a0966491904ed659642f408e94b874e3b2d357c51406f79db562b6b873e9b7.jpeg" alt="Amden One dashboard preview" loading="lazy" className="mt-8 rounded-xl shadow-2xl ring-1 ring-white/10 w-full object-cover" />
        </div>
        <p className="text-sm text-slate-500">© {new Date().getFullYear()} Amden One</p>
      </div>
      <div className="flex items-center justify-center p-6 sm:p-12">
        <div className="w-full max-w-md">
          <Link to="/" className="lg:hidden flex items-center gap-2 font-display font-extrabold text-xl text-navy mb-8">
            <span className="h-9 w-9 rounded-full overflow-hidden"><img src="/amden-logo.png?v=2" alt="Amden One" className="h-full w-full object-cover" /></span>
            Amden<span className="text-blue-accent">One</span>
          </Link>
          <h1 className="text-3xl font-bold tracking-tight text-navy">{title}</h1>
          {subtitle && <p className="mt-2 text-slate-500">{subtitle}</p>}
          <div className="mt-8">{children}</div>
          {footer && <div className="mt-6 text-sm text-slate-600">{footer}</div>}
        </div>
      </div>
    </div>
  );
}

export function Field({ label, ...props }) {
  return (
    <div>
      <label className="text-sm font-medium text-slate-700">{label}</label>
      <input {...props} className="mt-1 w-full rounded-lg border border-slate-300 px-3 py-2.5 focus:ring-2 focus:ring-blue-500 outline-none transition" />
    </div>
  );
}
